import React from "react";
import styled from "styled-components";
import { DiAtom, DiGithubBadge } from "react-icons/di";
import { FiMenu } from "react-icons/fi";
import { FaLinkedinIn, FaInstagram } from "react-icons/fa";
import { SiGmail } from "react-icons/si";
import { Bio } from "../../data/constants";

const Nav = styled.div`
  height: 76px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
  position: sticky;
  top: 0;
  z-index: 50;
  background: rgba(20, 22, 32, 0.55);
  backdrop-filter: blur(14px);
  -webkit-backdrop-filter: blur(14px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  @media screen and (max-width: 960px) {
    transition: 0.35s all ease;
  }
`;
const NavContainer = styled.div`
  display: flex;
  justify-content: space-between;
  height: 60px;
  z-index: 1;
  width: 100%;
  padding: 0 24px;
  max-width: 1200px;
`;
const NavLogo = styled.a`
  width: 80%;
  padding: 0 6px;
  display: flex;
  justify-self: flex-start;
  cursor: pointer;
  text-decoration: none;
  align-items: center;
  color: ${({ theme }) => theme.text_primary};
  @media screen and (max-width: 640px) {
    padding: 0 0px;
  }
`;
const MobileIcon = styled.div`
  display: none;
  @media screen and (max-width: 820px) {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(-100%, 50%);
    font-size: 1.5rem;
    cursor: pointer;
    color: ${({ theme }) => theme.text_primary};
  }
`;
const NavItems = styled.ul`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 32px;
  list-style: none;

  @media screen and (max-width: 820px) {
    display: none;
  }
`;
const NavLink = styled.a`
  color: ${({ theme }) => theme.text_primary};
  font-weight: 500;
  cursor: pointer;
  text-decoration: none;
  opacity: 0.9;
  transition: all 0.2s ease-in-out;
  &:hover {
    opacity: 1;
    color: ${({ theme }) => theme.primary};
  }
`;
const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  width: 80%;
  height: 100%;
  padding: 0 6px;
  @media screen and (max-width: 820px) {
    display: none;
  }
`;
const IcButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: start;
  // width:80%;
  height: 100%;
  padding: 0 6px;
  @media screen and (max-width: 820px) {
    display: none;
  }
`;
const IsButtonContainer = styled.div`
  display: flex;
  align-items: center;
  // justify-content:start;
  // width:80%;
  height: 100%;
  padding: 0 6px;
  @media screen and (max-width: 820px) {
    display: none;
  }
`;
const IconButton = styled.a`
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 18px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.06);
  padding: 10px 12px;
  cursor: pointer;
  height: 42px;
  transition:
    transform 0.18s ease,
    background 0.18s ease,
    border-color 0.18s ease;
  &:hover {
    transform: translateY(-2px);
    background: rgba(255, 255, 255, 0.1);
    border-color: rgba(255, 255, 255, 0.22);
  }
`;
const Span = styled.span`
  padding: 0 4px;
  font-weight: bold;
  font-size: 18px;
  text-decoration: none;
`;
const MobileMenu = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 16px;
  position: absolute;
  top: 76px;
  right: 0;
  width: 100%;
  padding: 12px 40px 24px 40px;
  background: rgba(20, 22, 32, 0.85);
  backdrop-filter: blur(16px);
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  transition: all 0.3s ease-in-out;
  transform: ${({ open }) => (open ? "translateX(0)" : "translateX(100%)")};
  border-radius: 0 0 20px 20px;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.3);
  opacity: ${({ open }) => (open ? "1" : "0")};
  z-index: ${({ open }) => (open ? "1" : "-1")};
`;
const MobileLink = styled.a`
  color: ${({ theme }) => theme.text_primary};
  font-weight: 600;
  cursor: pointer;
  text-decoration: none;
  padding: 10px 0;
  transition: all 0.2s ease-in-out;
  &:hover {
    color: ${({ theme }) => theme.primary};
  }
`;

export const Navbar = () => {
  const [open, setOpen] = React.useState(false);
  return (
    <Nav>
      <NavContainer>
        <NavLogo href="#about" aria-label="Go to top">
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <DiAtom size="2rem" />
            <Span>Portfolio</Span>
          </div>
        </NavLogo>
        <MobileIcon>
          <FiMenu
            onClick={() => {
              setOpen(!open);
            }}
          />
        </MobileIcon>
        <NavItems>
          <NavLink href="#about">About</NavLink>
          <NavLink href="#skills">Skills</NavLink>
          <NavLink href="#experience">Experience</NavLink>
          <NavLink href="#projects">Projects</NavLink>
          <NavLink href="#education">Education</NavLink>
        </NavItems>
        <ButtonContainer>
          <IconButton
            href={Bio.github}
            target="_blank"
            rel="noreferrer"
            aria-label="GitHub"
          >
            <DiGithubBadge size="1.9rem" color="#FFFFFF" />
          </IconButton>
        </ButtonContainer>
        <IcButtonContainer>
          <IconButton
            href={Bio.linkedin}
            target="_blank"
            rel="noreferrer"
            aria-label="LinkedIn"
          >
            <FaLinkedinIn size="1.35rem" color="#FFFFFF" />
          </IconButton>
        </IcButtonContainer>
        <IsButtonContainer>
          <IconButton
            href={Bio.insta}
            target="_blank"
            rel="noreferrer"
            aria-label="Instagram"
          >
            <FaInstagram size="1.35rem" color="#FFFFFF" />
          </IconButton>
        </IsButtonContainer>
        <IsButtonContainer>
          <IconButton
            href={Bio.mail}
            target="_blank"
            rel="noreferrer"
            aria-label="Email"
          >
            <SiGmail size="1.2rem" color="#FFFFFF" />
          </IconButton>
        </IsButtonContainer>
      </NavContainer>
      {open && (
        <MobileMenu open={open}>
          <MobileLink
            href="#about"
            onClick={() => {
              setOpen(!open);
            }}
          >
            About
          </MobileLink>
          <MobileLink
            href="#skills"
            onClick={() => {
              setOpen(!open);
            }}
          >
            Skills
          </MobileLink>
          <MobileLink
            href="#experience"
            onClick={() => {
              setOpen(!open);
            }}
          >
            Experience
          </MobileLink>
          <MobileLink
            href="#projects"
            onClick={() => {
              setOpen(!open);
            }}
          >
            Projects
          </MobileLink>
          <MobileLink
            href="#education"
            onClick={() => {
              setOpen(!open);
            }}
          >
            Education
          </MobileLink>
          <IconButton
            href={Bio.github}
            target="_blank"
            rel="noreferrer"
            style={{
              textDecoration: "none",
              justifyContent: "flex-start",
              gap: "10px",
              padding: "10px 14px",
            }}
          >
            <DiGithubBadge size="1.9rem" color="#FFFFFF" />
            <Span>GitHub Profile</Span>
          </IconButton>
        </MobileMenu>
      )}
    </Nav>
  );
};

export default Navbar;
